import ServerApi from './$server.api'

export default {
    createTicket,
    getTickets,
    updateTicket,
    deleteTicket
}

async function createTicket(data) {
    return await ServerApi.request('post', '/tickets', {data})
}

async function getTickets(query) {
    return await ServerApi.request('get', '/tickets', {query})
}

async function updateTicket(ticketId, data) {
    return await ServerApi.request('put', `/tickets/${ ticketId }`, {data})
}

async function deleteTicket(ticketId) {
    return await ServerApi.request('delete', `/tickets/${ ticketId }`)
}